import { render, staticRenderFns } from "./serve.vue?vue&type=template&id=6794cd53&scoped=true"
import script from "./serve.vue?vue&type=script&lang=js"
export * from "./serve.vue?vue&type=script&lang=js"
import style0 from "./serve.vue?vue&type=style&index=0&id=6794cd53&prod&lang=less&scoped=true"
import style1 from "./serve.vue?vue&type=style&index=1&id=6794cd53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6794cd53",
  null
  
)

export default component.exports